const nl = {
  avisoLegal: "Richtinggevend ontwerp op basis van de gegevens in NuvliPro. Het vervangt geen professioneel advies. Bekijk het met je boekhouder voordat je het indient.",
  lockPago: "Exports voor je boekhouder zijn een betaalde functie.",
  imp: { IVA: "btw", IGIC: "IGIC", IPSI: "IPSI" },
  ter: { comun: "Gemeenschappelijk gebied", canarias: "Canarische Eilanden", ceuta_melilla: "Ceuta en Melilla", foral_pv: "Baskenland", foral_navarra: "Navarra" },
  tipo: { autonomo: "Zelfstandige (natuurlijk persoon)", sociedad: "Vennootschap" },
  q: { 1: "K1 · jan–mrt", 2: "K2 · apr–jun", 3: "K3 · jul–sep", 4: "K4 · okt–dec" },
  periodoT: "K{{n}} {{year}}",
  periodoP: "Voorschot {{n}} {{year}}",
  sub: "{{imp}} en inkomstenbelasting per kwartaal en jaaroverzicht",
  pie: "De bedragen worden automatisch berekend op basis van je uitgaande facturen en geregistreerde uitgaven per kwartaal.",
  regimen: {
    proTitulo: "Pro-abonnement:",
    proTexto: "automatisch belastingstelsel per gebied (btw, IGIC en Haciendas Forales), Model 420 op de Canarische Eilanden, Model 202 voor vennootschappen, Model 111, deadline-herinneringen en controle van de gegevenskwaliteit.",
    pasarPro: "Overstappen op Pro",
    modelo: " (model {{m}})",
    pagos: "voorschotten: model {{m}}",
    corregido: "Handmatig aangepast · wijzigen",
    detectado: "Automatisch herkend · corrigeren",
    faltan: "Je fiscale gegeven ontbreekt ({{que}}): we gaan uit van gemeenschappelijk gebied en zelfstandige tot je het invult.",
    cp: "postcode", nif: "NIF/CIF", y: " en ",
    foral: "Je fiscale adres ligt in {{nombre}}: btw en voorschotten worden ingediend bij de {{hacienda}}, met eigen forale modellen en termijnen. Dit ontwerp dient als leidraad; je boekhouder stelt de aangifte op.",
    ipsi: "In Ceuta en Melilla geldt de IPSI in plaats van btw. NuvliPro berekent die nog niet: vraag je boekhouder de aangifte op te stellen.",
  },
  card: {
    baseVentas: "Maatstaf verkopen", baseGastos: "Maatstaf uitgaven", rep: "Verschuldigde {{imp}}", sop: "Aftrekbare {{imp}}",
    irpf: "Ingehouden inkomstenbelasting (IRPF)", horas: "Gewerkte uren", bases: "Maatstaf per {{imp}}-tarief", base: "{{imp}} {{pct}}% · maatstaf",
    resultado: "Resultaat {{imp}} ({{estado}})", aIngresar: "te betalen", aCompensar: "te verrekenen",
    igicCanarias: "IGIC · werven op de Canarische Eilanden", ivaFuera: "btw · werven buiten de Canarische Eilanden",
    ipsiRep: "Verschuldigde IPSI", ipsiAviso: "IPSI niet berekend: je boekhouder stelt die op.",
    isp: "Verlegging van heffing · apart", ispEmitidas: "Uitgaand (maatstaf, zonder belasting)", ispRecibidas: "Inkomend (maatstaf)",
    ispCuota: "Zelf aangegeven belasting (aangegeven en afgetrokken)",
  },
  btn: {
    docGestoria: "Doc. boekhouder", docAnual: "Doc. boekhouder (jaar)", enviar: "Verzenden", m: "M.{{m}}", modelo: "Model {{m}}",
    m420Pro: "Model 420: Pro-abonnement", excel: "Excel", ver130: "130 bekijken",
  },
  anual: { titulo: "Jaaroverzicht {{year}}", ipsi: "Verschuldigde IPSI (niet berekend)", resultado: "Jaarresultaat {{imp}}" },
  doc: { gestoria: "Document voor de boekhouder", modelo: "Model {{m}}" },
  toast: {
    generado: "{{doc}} aangemaakt", trimestre: " (K{{n}})", anual: " (jaar {{year}})", error: "Kon niet worden aangemaakt: {{doc}}",
    excelOk: "Rapport {{year}} geëxporteerd voor je boekhouder (XLSX)", excelError: "Het rapport kon niet worden geëxporteerd",
    m130Error: "Model 130 kon niet worden berekend", reduccionError: "De vermindering kon niet worden opgeslagen",
  },
  m130: {
    titulo: "Model 130 — Inkomstenbelasting", acum: "(cumulatief K{{n}})", anual: "(jaar {{year}})",
    desc: "Cumulatief voorschot van het jaar, min inhoudingen en wat je in eerdere kwartalen betaalde.",
    ingresos: "Belastbare inkomsten (cumulatief)", gastos: "Aftrekbare kosten (cumulatief)", rendimiento: "Netto-inkomen",
    reduccion: "Vermindering {{pct}} % moeilijk te verantwoorden kosten", pago: "Voorschot ({{pct}} %)",
    retenciones: "Ondergane inhoudingen", anteriores: "Betalingen van eerdere kwartalen",
    aIngresar: "Te betalen resultaat", negativo: "Negatief resultaat (te betalen: € 0)",
    marcar: "Pas de vermindering van {{pct}} % voor moeilijk te verantwoorden kosten toe (max. {{max}}/jaar). Overleg met je boekhouder.",
    cerrar: "Sluiten", pdf: "PDF downloaden",
  },
  m202: {
    titulo: "Model 202 — voorschotten {{year}} (schatting)",
    desc: "Vennootschapsbelasting: {{pct}} % van de cumulatieve winst van het jaar. Je boekhouder kan een andere methode gebruiken.",
    plazo: "Voorschot {{p}} · in te dienen van 1 tot 20 {{mes}}", mes: { 1: "april", 2: "oktober", 3: "december" },
    tramo: { 3: "jan–mrt", 9: "jan–sep", 11: "jan–nov" }, beneficio: "Cumulatieve winst ({{tramo}})",
    cuota: "{{pct}} % van de winst", menos: "Inhoudingen en eerdere voorschotten", estimacion: "Geschat te betalen",
  },
  m111: {
    titulo: "Model 111 — inhoudingen {{year}}",
    desc: "Inhoudingen op lonen (vul je zelf in) en op zelfstandigen die je met inhouding betaalt (uit je uitgaven).",
    nominas: "Inhoudingen op lonen (handmatig)", profesionales: "Zelfstandigen: {{n}} ontvanger(s), maatstaf {{base}}",
    total: "Totaal te betalen", guardado: "Inhoudingen op lonen K{{n}} opgeslagen",
    errorGuardar: "Het bedrag kon niet worden opgeslagen", invalido: "Vul een geldig bedrag in, bijvoorbeeld 1.234,56",
  },
  enviar: {
    titulo: "K{{n}} {{year}} naar je boekhouder sturen",
    desc: "Je boekhouder krijgt een e-mail met deze pdf's als bijlage. Antwoordt hij, dan komt de e-mail bij jou terecht.",
    email: "E-mail van de boekhouder", placeholder: "boekhouder@voorbeeld.be", boton: "Verzenden", ok: "K{{n}} {{year}} verzonden naar {{email}} ({{docs}} PDF)",
    error: "Controleer het e-mailadres van je boekhouder",
  },
  avisos: {
    plazos: "Komende termijnen", sinPlazos: "Geen komende termijnen.",
    forales: "Forale termijnen: de modellen worden ingediend bij je Hacienda Foral en je boekhouder stelt ze op.",
    modelos: "Modellen {{m}}", rango: "{{periodo}}: van {{desde}} tot {{hasta}}",
    hoy: "Eindigt vandaag", unDia: "Nog 1 dag", dias: "Nog {{n}} dagen",
    recordatorio: "We herinneren je via een melding en e-mail 10 dagen voordat elke termijn afloopt.",
    calidad: "Gegevenskwaliteit {{year}}", ok: "Alles in orde: er ontbreken geen gegevens in je facturen van dit jaar.",
    revisar: "Nakijken", exenta: "Als vrijgesteld markeren", exentaOk: "Uitgave gemarkeerd als vrijgesteld", exentaError: "De uitgave kon niet worden gemarkeerd",
  },
  calidad: {
    facturas_nif: "Uitgaande facturen zonder of met ongeldig NIF van de klant",
    facturas_cp_obra: "Werffacturen zonder postcode van de werf (voeg die toe in de werffiche)",
    gastos_sin_impuesto: "Inkomende facturen zonder uitgesplitste belasting (btw of IGIC op 0)",
    gastos_nif: "Inkomende facturen zonder of met ongeldig NIF van de leverancier",
  },
  ajustes: {
    titulo: "Belastingstelsel (Kwartaaloverzicht)", det1: "Automatisch herkend:", det2: "op basis van je postcode en",
    det3: "op basis van je NIF/CIF. Wijzig het alleen als het niet klopt.",
    nota: "Deze wijziging geldt alleen voor het Kwartaaloverzicht. Nieuwe facturen stellen de belasting nog steeds voor op basis van jouw postcode en die van de klant.",
    territorio: "Fiscaal gebied", tipo: "Soort belastingplichtige", automatico: "Automatisch ({{x}})",
    autonomo130: "Zelfstandige (model 130)", sociedad202: "Vennootschap (model 202)",
    bloqueado: "Het automatische stelsel hoort bij het Pro-abonnement.", guardado: "Belastingstelsel opgeslagen", error: "Kon niet worden opgeslagen",
  },
};

export default nl;
